import React from 'react';

const Network = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <title>network</title>
    <path
      className="st0"
      d="M22,6.8c0.5-0.7,0.5-1.5,0-2.2c-0.5-0.8-1.5-1.2-2.5-1c-2-1.9-4.7-3-7.6-3c-2.1,0-4.2,0.6-5.8,1.6
	C5.5,1.8,4.7,1.8,4,2.2C3,2.8,2.6,4,3.1,5c-1.5,1.9-2.3,4.2-2.3,6.8c0,3.6,1.8,6.9,4.5,9c-0.1,0.5,0.1,0.9,0.2,1.3
	c0.6,1,1.9,1.4,2.9,0.8c0.1-0.1,0.2-0.1,0.4-0.3c1,0.3,2,0.5,3.1,0.5c6.1,0,11.1-5,11.1-11.1C23.1,10,22.7,8.4,22,6.8z M15.2,16.9
	c-1.4-1.2-2.3-2.6-3.1-3.9c1.8-1.6,2.8-3.6,3.4-5.6c1.2-0.2,2.2-0.6,2.9-0.9c0,0.1,0,0.2,0.1,0.2c0.2,0.3,0.5,0.6,0.8,0.8
	C19.2,8.8,19.1,13.3,15.2,16.9z M9.4,20.1c-0.1-0.1-0.1-0.2-0.1-0.3c-0.5-0.9-1.4-1.2-2.3-1c-0.6-1.1-0.9-2.1-1.2-3.2
	c2.2-0.1,4-0.8,5.6-1.9c0.8,1.4,1.8,2.6,3.1,3.9C13.1,18.6,11.5,19.4,9.4,20.1z M11.6,12.1c-0.9-1.7-1.3-3.4-1.5-4.9
	c1.1,0.3,2.1,0.4,3.1,0.4c0.4,0,0.8,0,1.1-0.1C13.8,9.2,13,10.8,11.6,12.1z M10.9,12.8c-1.4,1.1-3.2,1.8-5.4,1.9
	c-0.8-3.7-0.3-6.8,0-8.4C5.7,6.2,5.9,6.1,6.1,6c0.2-0.1,0.3-0.2,0.4-0.3c0.8,0.6,1.7,1,2.5,1.3C9.3,8.7,9.8,10.7,10.9,12.8z
	 M7.1,4.8C7.3,4.2,7.2,3.5,6.9,3L6.8,3C7.5,2.6,8.2,2.3,9,2c-0.1,0.6-0.2,2-0.1,3.8C8.3,5.5,7.7,5.2,7.1,4.8z M18.1,5.6
	c-0.5,0.2-1.3,0.6-2.4,0.8c0.4-1.7,0.5-3.1,0.5-3.9c1,0.5,1.8,1,2.5,1.7C18.4,4.6,18.1,5.1,18.1,5.6z M15.2,2.1c0,0.5,0,2.3-0.6,4.4
	c-1.4,0.2-2.9,0.2-4.7-0.4c-0.2-2.5,0.1-4.2,0.1-4.3H10c0.6-0.1,1.3-0.2,1.9-0.2C13.1,1.5,14.2,1.8,15.2,2.1z M3.8,5.8
	C4,6,4.2,6.1,4.4,6.2C4,7.9,3.6,11,4.4,14.6c-0.7,0-1.5-0.1-2.2-0.2c-0.2-0.9-0.4-1.8-0.4-2.7C1.8,9.5,2.5,7.4,3.8,5.8z M2.5,15.5
	c0.8,0.1,1.5,0.1,2.1,0.1C5,16.8,5.4,18,6.1,19.2c-0.2,0.1-0.3,0.3-0.4,0.5C4.3,18.6,3.2,17.2,2.5,15.5z M9.5,21.5
	c0.1-0.1,0.1-0.3,0.1-0.5c2.4-0.8,4.2-1.8,5.6-2.9c0.8,0.6,1.6,1.2,2.6,1.9c-1.6,1.1-3.6,1.9-5.9,1.9C11.1,21.9,10.3,21.8,9.5,21.5z
	 M18.6,19.4c-1-0.5-1.9-1.2-2.7-1.9c3.8-3.5,4.2-8,4.2-9.7c0.4,0,0.8-0.1,1.1-0.2c0.5,1.2,0.9,2.7,0.9,4.2
	C22.1,14.8,20.8,17.5,18.6,19.4z"
    />
  </svg>
);

export default Network;
